export class UnapproveRiskCalculationCommand {
    public comment: string;

    public constructor(init: Partial<UnapproveRiskCalculationCommand>) {
        Object.assign(this, init);
    }
}
